module.exports = __webpack_public_path__ + "img/bb2bd84.png";